import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";

import { ConsultationSessionType, EvalIds } from "graphql/generated";
import { CONSULT_ONLY_TREAMENTS } from "src/constants/Evaluations";
import { URL_GUEST_EVAL_V2, URL_HOME } from "src/constants/url.constants";
import { useCheckPatientLogIn } from "src/hooks";
import { checkIsCountryHaveTextConsult } from "src/utils";

type Props = {
  isRequiredConsultType: boolean;
  latestQuestionId: string;
  evaluationId: EvalIds;
};
const useEvaluationFlow = ({ isRequiredConsultType, latestQuestionId, evaluationId }: Props) => {
  const [isShowConsultType, setIsShowConsultType] = useState(!latestQuestionId);
  const [isShowEval, setIsShowEval] = useState(false);

  const { isGuest } = useCheckPatientLogIn();

  const [consultType, setConsultType] = useState(
    checkIsCountryHaveTextConsult() && !CONSULT_ONLY_TREAMENTS.includes(evaluationId)
      ? ConsultationSessionType.Text
      : ConsultationSessionType.Video
  );

  const router = useRouter();

  useEffect(() => {
    if (latestQuestionId) {
      // have saved answer => show the eval and reload to the latest question
      setIsShowConsultType(false);
      setIsShowEval(true);
    } else {
      // don't have saved answer => return to the initial state
      setIsShowConsultType(false);
      setIsShowEval(false);
    }
  }, [latestQuestionId]);

  useEffect(() => {
    if (isGuest) {
      router.push(URL_GUEST_EVAL_V2(evaluationId as EvalIds));
    }
  });

  const setNextEvalStep = useCallback(() => {
    if (isRequiredConsultType) {
      setIsShowConsultType(true);
    } else {
      setIsShowEval(true);
    }
  }, [isRequiredConsultType]);

  const hideEvalFlow = useCallback(() => {
    if (isRequiredConsultType) {
      setIsShowEval(false);
    } else {
      router.push(URL_HOME);
    }
  }, [isRequiredConsultType, router]);

  const showEvalFlow = useCallback(() => {
    setIsShowEval(true);
    setIsShowConsultType(false);
  }, []);

  const clickBackFromSelectConsult = useCallback(() => {
    setIsShowConsultType(false);
  }, []);

  return {
    isShowEval,
    consultType,
    isShowConsultType,
    setNextEvalStep,
    setConsultType,
    setIsShowConsultType,
    showEvalFlow,
    hideEvalFlow,
    clickBackFromSelectConsult,
    isGuest
  };
};

export default useEvaluationFlow;
